import * as actionTypes from '../actions/types';

const initialState = [];

const filters = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_FILTER:
      return [...new Set([...state, action.filter])];
    case actionTypes.REMOVE_FILTER:
      return state.filter((item) => item !== action.filter);
    case actionTypes.REMOVE_ALL_FILTERS:
      return initialState;
    default:
      return state;
  }
};

export default filters;

export const getFilters = (state) => state;
